import ReilmLogo from '../components/ReilmLogo'
import { Link, useNavigate } from 'react-router-dom'
import { ReactComponent as AvatarIcon } from  '../assets/avatar1.svg'
import { useAuth } from './auth/AuthContext'

const AppNavbar = () => {
  const navigate = useNavigate()
  const { user, logout } = useAuth()

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  // M-4.1 (13.08 reply): Микола scoped the "Upgrade" relabel to a trial user only — he never
  // asked for the old "Pricing" link to disappear for anyone else. A paying subscriber
  // (active, past_due, or any other non-trial status the schema carries) still needs a path
  // to /pricing for Change Plan, so that link stays for real-but-non-trial subscriptions.
  // A legacy account with no subscription record at all gets neither link, same as before.
  const isTrialing = user?.subscription?.status === 'trialing'
  const hasNonTrialSubscription = Boolean(user?.subscription?.status) && !isTrialing

  return (
    <header className="min-h-[72px] md:h-[96px] bg-brand-pageFill border-b border-black/5">
      {/* The trialing row (131px logo + Pipeline + Upgrade + Logout) is ~358px of content, so with
          the 16px gutters it fits single-row from 390px up; below that it wraps rather than
          scrolling sideways or losing the right gutter (review of e2a3a2a, measured at 360-390). */}
      <div className="h-full flex flex-nowrap max-[389px]:flex-wrap items-center justify-between gap-2 px-4 md:px-6 max-[389px]:py-2">
        <div className="flex items-center gap-16">
          <ReilmLogo className="w-[131px] h-[28px] shrink-0" />
        </div>

        {/* The logo is deliberately inert in here (Микола), so this nav is the only way out of
            the platform. */}
        <nav className="flex items-center gap-6 md:gap-12 text-[15px] md:text-[18px] font-medium">
          <Link
            to="/pipeline"
            className="text-brand-dark hover:text-brand-green transition font-semibold"
          >
            Pipeline
          </Link>
          {hasNonTrialSubscription && (
            <Link
              to="/pricing"
              className="text-brand-dark hover:text-brand-green transition font-semibold"
            >
              Pricing
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-2 md:gap-4 shrink-0">
          {/* Own gap-2 (8px) rather than the container's, which grows to 16px at md — his spec
              gives 8px flat, not a value that step up with breakpoint. */}
          <div className="flex items-center gap-2">
            {isTrialing && (
              <Link
                to="/pricing"
                className="w-[100px] h-[40px] flex items-center justify-center shrink-0 rounded-full border border-brand-fieldBdr text-brand-dark text-[14px] font-semibold hover:border-brand-green hover:text-brand-green transition-colors"
              >
                Upgrade
              </Link>
            )}
            <AvatarIcon className="hidden sm:block" />
          </div>
          <button
            type="button"
            onClick={handleLogout}
            className="text-brand-dark hover:text-brand-green text-[15px] md:text-[16px] font-semibold transition"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  )
}

export default AppNavbar